import { gql } from '@apollo/client';
import { ORDER_SUMMARY_FRAGMENT } from '../useOrderSummary';
import { UpdateOrderAction, OrderState } from '../useUpdateOrder';

export type Order = {
  __typename: 'RestOrder';
  attributes: {
    __typename: 'RestOrderAttributes';
    orderNumber: string;
    message: string;
    errors: [];
  };
};

export type ChargeOrderMutation = {
  chargeOrder: {
    __typename: 'UpdateOrderPayload';
    data: Order[];
  };
};

export type ChargeOrderMutationVariables = {
  orderId: string;
  input: {
    data: {
      action_type: UpdateOrderAction;
      attributes: {
        country_code: string;
        order_state: OrderState;
        payment_id: number;
        selected_items_ids: number[];
        use_reward_points: boolean;
        use_site_credit: boolean;
      };
      id: string;
      type: 'orders';
    };
  };
};

export const CHARGE_ORDER_MUTATION = gql`
  mutation ChargeOrder($orderId: String!, $input: ChargeOrderMutationVariables!) {
    chargeOrder(orderId: $orderId, input: $input)
      @rest(
        type: "UpdateOrderPayload"
        endpoint: "cart"
        path: "/v3.5/orders/{args.orderId}"
        method: "PATCH"
      ) {
      data @type(name: "RestOrderSummary") {
        ...OrderSummaryFragment
      }
    }
  }
  ${ORDER_SUMMARY_FRAGMENT}
`;
